import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import { HomePage } from '../pages/Home/HomePage';
import { LoginPage } from '../pages/Login/LoginPage';
import { RegisterPage } from '../pages/Register/RegisterPage';
import { RepairPage } from '../pages/Repair/RepairPage';
import { SearchPage } from '../pages/Repair/SearchPage';
import { RepairDetailPage } from '../pages/Repair/ResultPage';
import { MemberServiceActionPage } from '../pages/Member/MemberServiceActionPage';
import { MemberActionPage } from '../pages/Member/MemberActionPage';
import { EditMemberPage } from '../pages/Member/EditMemberPage';
import { ChangePasswordPage } from '../pages/Member/ChangePasswordPage';
import { SetAlertPage } from '../pages/Member/SetAlertPage';
import { ServiceActionPage } from '../pages/Service/ServiceActionPage';
import { ProductListPage } from '../pages/Product/ProductListPage';
import { RepairHistoryPage } from '../pages/Repair/RepairHistoryPage';
import { ForgetPasswordPage } from '../pages/ForgetPassowrd/ForgetPassword';
import { RecoverPasswordPage } from '../pages/RecoverPassword/RecoverPassword';
import { FeedbackPage } from '../pages/Feedback/FeedbackPage';
import { FeedbackActionPage } from '../pages/Feedback/FeedbackAction';
import { FeedbackHistoryPage } from '../pages/Feedback/FeedbackHistoryPage';
import { RepairHistoryDetailPage } from '../pages/Repair/RepairHistoryDetailPage';
import { useLoading } from '../units/loading';
import { usePartner } from '../hooks/usePartner';
import { SatisfactionPage } from '../pages/Satisfaction/SatisfactionPage';
import { MoreNewsPage } from '../pages/News/MoreNewsPage';
import { PrivacyPage } from '../pages/Privacy/PrivacyPage';
import { TermsPage } from '../pages/Terms/TermsPage';

function LiffRedirect() {
    const query = new URLSearchParams(window.location.search);
    const liffState = query.get('liff.state') || '';
    const liffStateUrl = new URL(`${window.location.origin}${liffState}`);
    query.delete('liff.state');

    return (liffState ? (
        <Redirect to={`${liffState.replace(/(\?.*)/, '')}?${query.toString()}${liffStateUrl.searchParams}${window.location.hash}`} />
    ) : (
        <Redirect to={`/home${window.location.search}${window.location.hash}`} />
    ));
}

type AuthRouterProps = {
    children: React.ReactElement,
};

function AuthRouter(props: AuthRouterProps): React.ReactElement {
    const { children } = props;
    const { setIsLoading } = useLoading();
    const [innerLoading, setInnerLoading] = useState(true);
    const { partner, isLoading: isPartnerLoading } = usePartner();

    useEffect(() => {
        setIsLoading(isPartnerLoading);
        setInnerLoading(isPartnerLoading);
    }, [isPartnerLoading]);

    if (innerLoading) {
        return (<div />);
    }

    return partner ? children : (<Redirect to={`/login?redirect=${window.location.pathname}`} />);
}

function AppRouter(): React.ReactElement {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={LiffRedirect} />
                <Route path="/home" exact component={HomePage} />
                <Route path="/login" exact component={LoginPage} />
                <Route path="/register" exact component={RegisterPage} />
                <Route path="/forgetPassword" exact component={ForgetPasswordPage} />
                <Route path="/recover_passwd" exact component={RecoverPasswordPage} />
                <Route path="/repair" exact component={RepairPage} />
                <Route path="/repair/search" exact component={SearchPage} />
                <Route path="/repair/search/:name" exact component={RepairDetailPage} />
                <Route path="/repair_question" exact component={SatisfactionPage} />
                <Route path="/front_news_more" exact component={MoreNewsPage} />
                <Route path="/privacy" exact component={PrivacyPage} />
                <Route path="/terms" exact component={TermsPage} />
                <AuthRouter>
                    <Switch>
                        <Route path="/memberService/action" exact component={MemberServiceActionPage} />
                        <Route path="/member/action" exact component={MemberActionPage} />
                        <Route path="/member/edit" exact component={EditMemberPage} />
                        <Route path="/member/changePassword" exact component={ChangePasswordPage} />
                        <Route path="/member/setAlert" exact component={SetAlertPage} />
                        <Route path="/feedback" exact component={FeedbackActionPage} />
                        <Route path="/feedback/add" exact component={FeedbackPage} />
                        <Route path="/feedback/history" exact component={FeedbackHistoryPage} />
                        <Route path="/service/action" exact component={ServiceActionPage} />
                        <Route path="/product/list" exact component={ProductListPage} />
                        <Route path="/repair/history" exact component={RepairHistoryPage} />
                        <Route path="/repair/history/:name" exact component={RepairHistoryDetailPage} />
                    </Switch>
                </AuthRouter>
                <Redirect to="/" />
            </Switch>
        </BrowserRouter>
    );
}

export { AppRouter };
